import React from "react";
import { Button } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

function CreateNewButton({ onClick }) {
  return (
    <Button
      sx={{ paddingLeft: "10px", paddingRight: "10px" }}
      variant="contained"
      onClick={onClick}
    >
      <AddRoundedIcon />
      Create New
    </Button>
  );
}

export default CreateNewButton;
